<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2022-01-12 18:03:34
 * @LastEditors: your name
 * @Description:按钮
-->
<template>
  <el-button v-bind="$attrs" :icon="elIcon" class="HButton">
    <i
      v-if="position === 'left'"
      class='iconfont'
      :class="[{left:position === 'left' && icon},icon]"
      :style="{fontSize}"
      ></i>
    <template v-if="!slotDefault"><slot></slot></template>
    <i
      v-if="position === 'right'"
      class='iconfont'
      :class="[{right:position === 'left' && icon},icon]"
      :style="{fontSize}"
      ></i>
  </el-button>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  useSlots
} from 'vue';
export default defineComponent({
  name: 'HButton',
  components: {},
  props: {
    icon: {
      type: String
    },
    elIcon: {
      type: String
    },
    fontSize: {
      type: String,
      default: '16px'
    },
    // 图标的位置 left | right
    position: {
      type: String,
      default: 'left'
    }
  },
  setup(props) {
    const data = reactive({});
    const refData = toRefs(data);

    const slotDefault = !useSlots().default;
    return { ...refData, slotDefault };
  }
});
</script>
<style  lang='scss' scoped >
.HButton {
  .left{
    margin-right: 5px;
  }
  .right{
    margin-left: 5px;
  }
}
</style>